module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Hashtag w nagłówku",
      "error": _vm.errors[_vm.addLanguageSuffix('header_hashtag')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('header_hashtag')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('header_hashtag'), $$v)
      },
      expression: "form[addLanguageSuffix('header_hashtag')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data w nagłówku",
      "error": _vm.errors[_vm.addLanguageSuffix('header_date')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('header_date')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('header_date'), $$v)
      },
      expression: "form[addLanguageSuffix('header_date')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data rozpoczęcia",
      "error": _vm.errors.start_date
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Data rozpoczecia festiwalu"
    },
    model: {
      value: (_vm.form.start_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_date", $$v)
      },
      expression: "form.start_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data zakończenia",
      "error": _vm.errors.end_date
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Data zakończenia festiwalu"
    },
    model: {
      value: (_vm.form.end_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "end_date", $$v)
      },
      expression: "form.end_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Pokaż zegar odliczający do początku festiwalu"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.show_counting_down),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_counting_down", $$v)
      },
      expression: "form.show_counting_down"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Domena z biletami",
      "error": _vm.errors.tickets_url
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "https://www.altersklep.pl"
    },
    model: {
      value: (_vm.form.tickets_url),
      callback: function($$v) {
        _vm.$set(_vm.form, "tickets_url", $$v)
      },
      expression: "form.tickets_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Odnośnik do polityki prywatności",
      "error": _vm.errors.policy_link
    }
  }, [_c('link-component', {
    attrs: {
      "errors": _vm.errors['policy_link']
    },
    model: {
      value: (_vm.form.policy_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "policy_link", $$v)
      },
      expression: "form.policy_link"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da096d5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/SettingsForm.vue
// module id = 805
// module chunks = 0